<p-toast position="top-center"></p-toast>
<p-confirmDialog #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-col items-center !p-8 !bg-slate-0 dark:!bg-slate-900 rounded-border">
      <div
        class="confirm-dialog-icon-badge rounded-full inline-flex shrink-0 justify-center items-center h-24 w-24 !-mt-20"
      >
        <i [ngClass]="message.icon ? message.icon + ' !text-5xl' : 'ph ph-info !text-5xl'"></i>
      </div>
      <p class="font-bold !text-2xl block !mb-2 !mt-6 max-w-40rem">{{ message.header }}</p>
      <p class="!mb-0 dialog-p max-w-40rem" [innerHTML]="message.message"></p>
      <div class="flex items-center gap-2 !mt-8">
        <p-button [label]="message.rejectLabel ?? 'No'" (onClick)="cd.onReject()" [outlined]="true"></p-button>
        <p-button [label]="message.acceptLabel ?? 'Yes'" (onClick)="cd.onAccept()"></p-button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
<router-outlet></router-outlet>
<p-toast key="orgToast" position="top-center" [life]="10000">
  <ng-template let-message pTemplate="message">
    <div class="w-full">
      <h3 class="!m-0 !p-0 !mb-1 !text-lg text-primary">{{ message.summary }}</h3>
      <p class="!m-0" [innerHTML]="message.detail"></p>
    </div>
  </ng-template>
</p-toast>
